export const documentTypes = [
  ".jpeg",
  ".jpg",
  ".png",
  ".doc",
  ".docx",
  ".pdf",
  ".csv",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".xps",
  ".rar",
  ".zip",
  ".7z"
];

export const imageTypes = [
  ".jpeg",
  ".jpg",
  ".png"
];

export function validateFile(name, acceptableTypes) {
  var iPos = name.lastIndexOf(".");
  var ext = name.substring(iPos, name.length);

  if (!acceptableTypes.includes(ext)) return false;
  return true;
}

export function getExtension(name){
  console.log('got name', name)
    var iPos = name.lastIndexOf(".");
    var ext = name.substring(iPos, name.length);
    console.log('ext', ext)
    return ext;
}


// WEBPACK FOOTER //
// ./src/helpers/Documents.js